<template>
    <div class="main-content">
        <the-header :title="t('Create user')"/>
        <user-details :create-user="true"/>
    </div>
</template>
<script>
    import TheHeader from '../../../admin/Layout/TheHeader'
    import NavBody from '../../../admin/Layout/NavBody'
    import UserDetails from "./manage/Details";

    export default {
        components: {
            UserDetails,
            TheHeader,
            NavBody,
        },
        mounted() {
            this.$store.commit('users/resetItem');
        },
    }
</script>



// WEBPACK FOOTER //
// src/pages/private/users/Create.vue